<template>
  <div>
    <h-loading v-if="isLoading" />

    <div v-else>
      <div v-if="selectableInvoices.length" class="d-flex align-center px-5 pt-4">
        <v-checkbox
          :input-value="allSelected"
          :indeterminate="someSelected"
          @change="toggleAll"
          :label="$t('hausefulInvoices.selectAll')"
          class="ma-0 pa-0"
          hide-details
          dense
        />
        <v-spacer />
        <span v-if="selectedHausefulInvoices.length" class="caption grey--text mr-4">
          {{ $t('hausefulInvoices.selectedCount', { count: selectedHausefulInvoices.length }) }}
          <span class="success--text font-weight-bold">{{ selectedTotal }}</span>
        </span>
        <v-btn
          @click="callGenerateAsaasBatchModal"
          :disabled="!selectedHausefulInvoices.length"
          color="primary"
          elevation="0"
        >
          <v-icon left small>
            mdi-file-document-multiple-outline
          </v-icon>
          <span class="caption">
            {{ $t('hausefulInvoices.modals.generateAsaasBatch.action') }}
          </span>
        </v-btn>
      </div>

      <div v-for="invoice in hausefulInvoices" :key="invoice.month" class="pa-5">
        <p class="headline mb-0 font-weight-light mb-2">{{ invoice.month }}</p>
        <InvoiceFortnight
          :fortnight="invoice.payments_first_half"
          title="firstHalf"
        />

        <InvoiceFortnight
          :fortnight="invoice.payments_second_half"
          title="secondHalf"
        />
      </div>
    </div>

    <p
      v-if="!isLoading && hausefulInvoices.length <= 0"
      class="pa-5 mb-0 text-center grey--text text--darken-1 body-2"
    >
      {{ $t('table.useTheFiltersToShowData') }}
    </p>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import InvoiceFortnight from './invoice/InvoiceFortnight'
import { listSelectableInvoices } from '@/views/invoices/hauseful/invoiceSelection'
import { catalogMonetary } from '@/util/catalog'

export default {
  name: 'HausefulInvoiceList',

  components: {
    InvoiceFortnight,
  },

  computed: {
    ...mapGetters([
      'isLoading',
      'hausefulInvoices',
      'selectedHausefulInvoices',
      'selectedHausefulInvoicesTotal',
    ]),

    /** Todas as filiais da tela achatadas: é o universo do "selecionar todas". */
    selectableInvoices() {
      return listSelectableInvoices(this.hausefulInvoices)
    },

    allSelected() {
      return this.selectableInvoices.length > 0
        && this.selectedHausefulInvoices.length === this.selectableInvoices.length
    },

    /** Traço no lugar do check quando a seleção é parcial. */
    someSelected() {
      return this.selectedHausefulInvoices.length > 0 && !this.allSelected
    },

    selectedTotal() {
      return catalogMonetary(this.selectedHausefulInvoicesTotal)
    },
  },

  methods: {
    ...mapActions(['fetchHausefulInvoices', 'openModal']),
    ...mapMutations(['setSelectedHausefulInvoices', 'setHausefulInvoiceBatchFailures']),

    toggleAll() {
      this.setSelectedHausefulInvoices(this.allSelected ? [] : this.selectableInvoices)
    },

    callGenerateAsaasBatchModal() {
      // Resultado do lote anterior não pode aparecer como se fosse deste.
      this.setHausefulInvoiceBatchFailures([])
      this.openModal('HAUSEFUL_INVOICE_GENERATE_ASAAS_BATCH_MODAL')
    },
  },
}
</script>
